import React from 'react'
import { isNil } from 'ramda'
import moment from 'moment'
import PropTypes from 'prop-types'
import { FormattedMessage } from 'react-intl'
import { Typography } from '@material-ui/core'

const UnsentDate = (props) => {
  const {
    unsendDate,
    unsentBy = {
      firstName: '',
      lastName: '',
    },
  } = props

  return (
    <Typography className="text-14 text-red-500">
      <FormattedMessage
        id="timeline.detail.message.unsent"
        values={{
          unsentBy: isNil(unsentBy)
            ? ''
            : `${unsentBy.firstName} ${unsentBy.lastName}`,
          unsentTime: moment(unsendDate).format('LT'),
          unsentDate: moment(unsendDate).format('MMM DD, YYYY'),
          b: (text) => <b>{text}</b>,
        }}
      />
    </Typography>
  )
}

UnsentDate.propTypes = {
  unsendDate: PropTypes.string,
  unsentBy: PropTypes.shape({
    firstName: PropTypes.string,
    lastName: PropTypes.string,
  }),
}

export default UnsentDate
